/**
 * Leads Page Tour Configuration
 * Introduces users to lead management features
 */

import { TourDefinition } from './tour.types';

export const leadsTour: TourDefinition = {
  id: 'leads-tour',
  name: 'Lead Management',
  page: '/leads',
  version: 5, // Updated with export CSV changes and notes info
  nextTourId: 'lead-assignment-tour', // Chain to lead assignment (skipped for non-agency users)
  steps: [
    {
      id: 'leads-overview',
      targetSelector: '[data-tour="leads-header"]',
      title: 'Your Lead Pipeline',
      description:
        'This is where you manage all your leads. View, filter, search, and take action on your prospects all in one place.',
      placement: 'bottom',
    },
    {
      id: 'leads-filters',
      targetSelector: '[data-tour="leads-filters"]',
      title: 'Filter Your Leads',
      description:
        'Use these filters to quickly find leads by status, source, date range, or any other criteria. This helps you focus on the leads that matter most.',
      placement: 'bottom',
    },
    {
      id: 'leads-search',
      targetSelector: '[data-tour="leads-search"]',
      title: 'Quick Search',
      description:
        'Search for any lead by name, phone number, or email. Results update instantly as you type.',
      placement: 'bottom',
    },
    {
      id: 'leads-table',
      targetSelector: '[data-tour="leads-table"]',
      title: 'Lead List',
      description:
        'Your leads are displayed here in a sortable table. Click on any lead to view their full details including notes, policies, and communication history.',
      placement: 'top',
    },
    {
      id: 'add-lead',
      targetSelector: '[data-tour="add-lead-button"]',
      title: 'Add New Leads',
      description:
        'Click here to manually add a new lead, or import leads in bulk from a CSV file.',
      placement: 'left',
    },
    {
      id: 'bulk-actions',
      targetSelector: '[data-tour="bulk-actions"]',
      title: 'Bulk Actions & Export',
      description:
        'Select multiple leads to update status, assign to team members, or export to CSV. Exports now include individual columns for each custom field for easy analysis in spreadsheet applications. Note: Agency owners can control agent export permissions in settings.',
      placement: 'bottom',
      // No skipIf - show to all users so they know about this feature
    },
  ],
};
